// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buttons[data-v-5a4a80fa]{display:flex}.btn[data-v-5a4a80fa]{min-width:130px;font-weight:600;font-size:1rem;line-height:1.21429rem}.btn.--square[data-v-5a4a80fa]{width:40px;min-width:40px;padding:0;display:flex;align-items:center;justify-content:center}.btn.--square .icon[data-v-5a4a80fa]{fill:#fff;stroke:transparent}a[data-v-5a4a80fa]{margin-right:15px}a+.btn[data-v-5a4a80fa]{padding-right:10px;padding-left:15px}", ""]);
// Exports
module.exports = exports;
